export enum ExportTypeEnum {
  UiModel = 'ui_model',
  GoogleSheets = 'google_sheets',
  Excel = 'xlsx',
  CSV = 'csv',
  BigQuery = 'big_query',
  S3 = 's3',
  Salesforce = 'salesforce',
  Snowflake = 'snowflake',
  Unknown = '__unknown__',
}
